export default "/assets/images/logo-footer.f6b022fe75e63906.svg";